import types from './types';

const setIncidents = (incidents) => ({
  type: types.SET_INCIDENTS,
  payload: {
    incidents
  }
});

const setIncidentsLoaded = (loaded) => ({
  type: types.SET_INCIDENTS_LOADED,
  payload: {
    loaded
  }
});

const setVisibleIncidents = (incidents) => ({
  type: types.SET_VISIBLE_INCIDENTS,
  payload: {
    incidents
  }
});

const addSelectedIncident = (incident) => ({
  type: types.ADD_SELECTED_INCIDENT,
  payload: {
    incident
  }
});

const removeSelectedIncident = (incident) => ({
  type: types.REMOVE_SELECTED_INCIDENT,
  payload: {
    incident
  }
});

const clearSelectedIncidents = () => ({
  type: types.CLEAR_SELECTED_INCIDENTS,
  payload: {}
});

const setIncidentListVisible = (visible) => ({
type: types.SET_INCIDENT_LIST_VISIBLE,
payload: {
  visible
}
});

const setQueriedIncidentsTotal = (queriedIncidentsTotal) => ({
  type: types.SET_QUERIED_INCIDENTS_TOTAL,
  payload: {
    queriedIncidentsTotal
  }
  });

  const setDisplayedIncidentsCount = (displayedIncidentsCount) => ({
    type: types.SET_DISPLAYED_INCIDENTS_COUNT,
    payload: {
      displayedIncidentsCount
    }
    });


/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  setIncidents,
  setIncidentsLoaded,
  addSelectedIncident,
  removeSelectedIncident,
  setVisibleIncidents,
  setIncidentListVisible,
  clearSelectedIncidents,
  setQueriedIncidentsTotal,
  setDisplayedIncidentsCount
};
